import React from "react"
import { FC } from "react"

import { Platform, IntegrationProfile } from "@vromo/models"
import Button from "@vromo/ui/components/Button"



const buttonText = (platform?: Platform) => {
    if (platform?.includes("square"))
        return "reconnect to Square"
    else
        return "edit/add"
}



export const EditButton: FC<{
    instance?: IntegrationProfile,
    action: () => void
}> = ({ instance, action }) => {

    if (instance?.completed && instance.platform.includes("square"))
        return null

    return (
        < Button
            darkGrey
            onClick={action}
        >
            {buttonText(instance?.platform)}
        </Button>
    )
}